import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import {
  adminFetchAllGalleryItems,
  deleteProduct,
  selectAdminGalleryItems,
  selectAdminGalleryLoading,
  setAdminGalleryItems,
} from "features/admin/Gallery/adminGallerySlice";
import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import GridTable from "../Common/GridTable";

interface GalleryTableProps {}

const GalleryTable: React.FC<GalleryTableProps> = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminGalleryItems = useSelector(selectAdminGalleryItems);
  const isLoading = useSelector(selectAdminGalleryLoading);

  useEffect(() => {
    dispatch(adminFetchAllGalleryItems());

    return () => {
      dispatch(setAdminGalleryItems([]));
    };
  }, []);

  const columns: ColDef[] = [
    {
      field: "title",
      headerName: "Заглавие",
      width: 400,
    },
    {
      field: "text",
      headerName: "Описание",
      width: 400,
    },
  ];

  const add = () => {
    navigate(`/gallery/add`);
  };

  const edit = (selectedId: string) => {
    const selectedItemRefId = adminGalleryItems.find(
      (item: { id: number }) => item.id === parseInt(selectedId)
    )?.refId;
    navigate(`/gallery/edit/${selectedItemRefId}`);
  };

  const remove = (ids: string[]) => {
    const allowDelete = window.confirm("Искате ли да изтриете?");

    if (allowDelete) {
      ids.forEach((id: string) => {
        const _refId = adminGalleryItems.find(
          (item: { id: number }) => item.id === parseInt(id)
        )?.refId;
        console.log(_refId);
        _refId &&
          batch(() => {
            dispatch(setResponseMessage({ message: "", hasError: false }));
            dispatch(deleteProduct(_refId));
          });
      });
    }
  };

  return (
    <GalleryTableContainer>
      <GridTable
        autoPageSize={true}
        data={adminGalleryItems}
        columns={columns}
        add={add}
        refresh={() => {}}
        remove={remove}
        edit={edit}
        isLoading={isLoading}
        searchProperty={"title"}
      />
    </GalleryTableContainer>
  );
};

const GalleryTableContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export default GalleryTable;
